/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InscriptionFormationDto
 */
export interface InscriptionFormationDto {
    /**
     * 
     * @type {number}
     * @memberof InscriptionFormationDto
     */
    idstade?: number;
    /**
     * 
     * @type {number}
     * @memberof InscriptionFormationDto
     */
    idmetier?: number;
}

/**
 * Check if a given object implements the InscriptionFormationDto interface.
 */
export function instanceOfInscriptionFormationDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function InscriptionFormationDtoFromJSON(json: any): InscriptionFormationDto {
    return InscriptionFormationDtoFromJSONTyped(json, false);
}

export function InscriptionFormationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InscriptionFormationDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idstade': !exists(json, 'idstade') ? undefined : json['idstade'],
        'idmetier': !exists(json, 'idmetier') ? undefined : json['idmetier'],
    };
}

export function InscriptionFormationDtoToJSON(value?: InscriptionFormationDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idstade': value.idstade,
        'idmetier': value.idmetier,
    };
}

